import * as React from 'react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observer, Provider } from 'mobx-react';
import { Page } from '../../components/atoms/applications/page';
import { observable } from 'mobx';
import { MembershipPlanUpdateState } from './states/MembershipPlanUpdateState';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Route, Switch } from 'react-router';
import { V3Routes } from '../../routes';
import { PlanSelectionPane } from '../../components/organisms/membership_plans/PlanSelectionPane';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { PaymentMethodPane } from '../../components/organisms/membership_plans/PaymentMethodPane';
import { ConfirmationPane } from '../../components/organisms/membership_plans/ConfirmationPane';

type Props = {
    match: {
        params: {
            membership_item_id: string;
        };
    };
};

@withNavigation(NavigationSpecs.application())
@observer
export class MembershipPlanUpdatePage extends React.Component<Props> {
    @observable pageState = new MembershipPlanUpdateState();

    componentDidMount(): void {
        const { membership_item_id } = this.props.match.params;
        this.pageState.init(GlobalStatesV3.currentUser, Number(membership_item_id));
    }

    render() {
        const { currentItemId, initState, currentSubscriptionSummary } = this.pageState;
        if (initState.submitting) {
            return <LoaderRow />;
        }
        if (!currentSubscriptionSummary) {
            return <NotFoundPage entityType={'プラン'} />;
        }
        return (
            <Page id="plan-update-page">
                <Provider pageState={this.pageState}>
                    <Switch>
                        <Route
                            exact
                            path={V3Routes.planUpdatePlanSelect(currentItemId).stringify()}
                            component={PlanSelectionPane}
                        />
                        <Route
                            exact
                            path={V3Routes.planUpdatePaymentMethod(currentItemId).stringify()}
                            component={PaymentMethodPane}
                        />
                        <Route
                            exact
                            path={V3Routes.planUpdateConfirm(currentItemId).stringify()}
                            component={ConfirmationPane}
                        />
                    </Switch>
                </Provider>
            </Page>
        );
    }
}
